import { useEffect, useRef, useState } from 'react';
import {
  orderCreationTimeStatus,
  orderTurboCase,
} from '../../../business/order/geoqueue';
import { OrderResponseFromStatusV2 } from '../../../business/shared/infra';

export function useTurboOrderMainCard(props: Props) {
  const { order } = props;
  const { isTurboqueue, createdAtStatus, isRTInStore } = orderTurboCase({
    order,
  });
  const [orderCreationStatus, setOrderCreationStatus] = useState<
    orderCreationTimeStatus
  >(createdAtStatus);
  const [hasTurboUrgency, setHasTurboUrgency] = useState<boolean>(false);
  const hasTurboOrderSenseOfEmergency =
    isRTInStore && createdAtStatus === 'urgency';
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setOrderCreationStatus(createdAtStatus);
  }, [createdAtStatus]);

  useEffect(() => {
    const startInterval = () => {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(
          () => setHasTurboUrgency(effect => !effect),
          500,
        );
      }
    };
    const stopInterval = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
    if (hasTurboOrderSenseOfEmergency) {
      startInterval();
    } else {
      stopInterval();
    }

    return () => stopInterval();
  }, [hasTurboOrderSenseOfEmergency]);

  return {
    isTurboqueue,
    orderCreationStatus,
    hasTurboUrgency,
  };
}

interface Props {
  order: OrderResponseFromStatusV2;
}
